function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 7">
      <path fill="currentColor" d="m0 7 7-7 7 7Z" />
    </svg>
  );
}

export default Icon;
